// ═══════════════════════════════════════════════════════════════
// RelationEdge.js — Edge custom React Flow (Family P2c)
// ═══════════════════════════════════════════════════════════════
// Trace la relation entre deux personnes. Style pointillé si
// source='ai_detected' (non validé humain), trait plein sinon.
// Label = type_label (ex "Parent", "Conjoint", "Enfant").
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';

const RelationEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data = {},
    markerEnd,
    selected,
}) => {
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
    });

    const isAI = data.source === 'ai_detected';
    const isDark = data.isDark;
    const muted = data.muted;
    const stroke = selected
        ? '#1D4ED8'
        : muted
            ? (isDark ? '#3a3a55' : '#cbd5e1')
            : (isDark ? '#6b7280' : '#94a3b8');

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                markerEnd={muted ? undefined : markerEnd}
                style={{
                    stroke,
                    strokeWidth: selected ? 2.2 : (muted ? 1.2 : 1.6),
                    strokeDasharray: isAI ? '6 4' : undefined,
                    transition: 'stroke 0.15s',
                }}
            />
            {data.label && (
                <EdgeLabelRenderer>
                    <div
                        style={{
                            position: 'absolute',
                            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                            background: isDark ? 'rgba(26,26,46,0.92)' : 'rgba(255,255,255,0.95)',
                            color: isDark ? '#94a3b8' : '#64748b',
                            border: `1px solid ${isDark ? '#2a2a44' : '#e2e8f0'}`,
                            borderRadius: 5,
                            padding: '1px 5px',
                            fontSize: 9,
                            fontWeight: 500,
                            letterSpacing: 0.15,
                            lineHeight: 1.3,
                            pointerEvents: 'all',
                            userSelect: 'none',
                            boxShadow: isDark ? 'none' : '0 1px 2px rgba(15,23,42,0.04)',
                            backdropFilter: 'blur(4px)',
                        }}
                        className="nodrag nopan"
                        title={isAI ? 'Détectée par l\'IA — à valider' : undefined}
                    >
                        {isAI && <span style={{ marginRight: 3, opacity: 0.6 }}>·</span>}
                        {data.label}
                    </div>
                </EdgeLabelRenderer>
            )}
        </>
    );
};

export default RelationEdge;
